export enum ImageSetUploadStage {
  Queued = 'queued',
  Starting = 'starting',
  Uploading = 'uploading',
  Completing = 'completing',
  NetworkError = 'networkError',
  Paused = 'paused',
  Uploaded = 'uploaded',
  Failed = 'failed',
  Cancelled = 'cancelled',
}

export enum UploadErrorAction {
  Ignore = 'ignore',
  WaitForNetwork = 'waitForNetwork',
  RefreshUrlAndRetry = 'refreshUrlAndRetry',
  Retry = 'retry',
  Fail = 'fail',
}

export enum ImagesUploadCompletionStatus {
  Done = 'done',
}
